// Machine codes some endpoints return in `detail` — mapped to friendly copy.
const CODE_MESSAGES = {
  OTP_INVALID: 'That code is incorrect or has expired — request a fresh one and try again.',
  STEPUP_REQUIRED: 'Extra verification required — confirm with one of your security factors.',
};

// Safely turn any FastAPI/axios error into a human-readable string.
// Handles: string detail, Pydantic 422 validation arrays ([{type, loc, msg, ...}]),
// object detail, and network errors — never returns an object (which crashes React).
export const apiErrorText = (err, fallback = 'Something went wrong — please try again.') => {
  const d = err?.response?.data?.detail ?? err?.response?.data?.message;
  if (typeof d === 'string' && d.trim()) return CODE_MESSAGES[d.trim()] || d;
  if (Array.isArray(d)) {
    const msgs = d.map((x) => (typeof x === 'string' ? x : x?.msg)).filter(Boolean);
    if (msgs.length) return msgs.join(' · ');
  }
  if (d && typeof d === 'object' && typeof d.msg === 'string') return d.msg;
  if (err?.response?.status) return `${fallback} (HTTP ${err.response.status})`;
  return fallback;
};

export default apiErrorText;
